/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FontSize = {
    Small: 'Small',
    Medium: 'Medium',
    Large: 'Large'
} as const;
export type FontSize = typeof FontSize[keyof typeof FontSize];


export function instanceOfFontSize(value: any): boolean {
    for (const key in FontSize) {
        if (Object.prototype.hasOwnProperty.call(FontSize, key)) {
            if (FontSize[key as keyof typeof FontSize] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FontSizeFromJSON(json: any): FontSize {
    return FontSizeFromJSONTyped(json, false);
}

export function FontSizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FontSize {
    return json as FontSize;
}

export function FontSizeToJSON(value?: FontSize | null): any {
    return value as any;
}

export function FontSizeToJSONTyped(value: any, ignoreDiscriminator: boolean): FontSize {
    return value as FontSize;
}

